import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
//import { eliminarInspector } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import estilos from './CuadroInspectorComponent.module.css'
import { useDispatch } from 'react-redux'
import Modal from '@mui/material/Modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CredencialComponent from './CredencialComponent'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { hostSocket } from '../../../configuraciones';

function TablaInspectoresComponent(props) {

    const dispatch = useDispatch()
    const handleRemoveInspector = (id) => {
        dispatch(eliminarInspector(id))
    }

    const data = [
        {
            name: 'Enero',
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Marzo',
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Abril',
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Mayo',
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Junio',
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Julio',
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Agosto',
            pv: 4300,
            amt: 2100,
        },
    ];

    const [openReasignarVisita, setOpenReasignarVisita] = React.useState(false);
    const handleOpenReasignarVisita = () => setOpenReasignarVisita(true);
    const handleCloseReasignarVisita = () => setOpenReasignarVisita(false);
    const [openEstadisticas, setOpenEstadisticas] = React.useState(false);
    const handleOpenEstadisticas = () => setOpenEstadisticas(true);
    const handleCloseEstadisticas = () => setOpenEstadisticas(false);
    const [openCredencial, setOpenCredencial] = React.useState(false);
    const handleOpenCredencial = () => setOpenCredencial(true);
    const handleCloseCredencial = () => setOpenCredencial(false);
    const [initialStateFormik, setInitialStateFormik] = React.useState({})

    const [cajaBusqueda, setCajaBusqueda] = React.useState('');
    let inspectoresAux = [];

    const [urlImg, setUrlImage] = React.useState("")

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleBuscarInspectores = (event) =>{
        setCajaBusqueda(event.target.value);
    }

    React.useEffect(() => {

        inspectores = solicitudes.fc_01_solicitudderegistro.filter(solicitud => solicitud.nombrerazonsocial.toUpperCase().includes(cajaBusqueda.toUpperCase()));
        checkPendientes ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 1 || solicitud.solicitudesuifc01[0]?.statusdelasolicitud == undefined) : null;
        checkInformeEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 2) : null;
        checkInformeEnRevision ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 3) : null;
        checkDictamenEmitido ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 4) : null;
        checkCompletadas ? solicitudesAux = solicitudesAux.filter(solicitud => solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 5) : null;
        setAux(solicitudesAux)
    }, [cajaBusqueda, checkPendientes, checkInformeEmitido, checkDictamenEmitido, checkCompletadas])


    return (
        <Fragment>
            <input className='form-control' type='text' placeholder='Ingrese el nombre de la razón social' onChange={handleBuscarInspectores} value={cajaBusqueda}></input> <br /><hr />
            <div className='row'>
                <div className='row'>
                    <div className='col-10'>
                    </div>
                    <div className='col-2'>
                        <button className='btn btn-primary'>Exportar a PDF</button>
                    </div>
                </div>
                <table className='table mt-3'>
                    <thead>
                        <tr>
                            <td>Fotografía</td>
                            <td>Datos</td>
                            <td>Gasolína y auto</td>
                            <td>Monto</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.inspectores.map((inspector, index) => {
                                console.log(inspector)
                                return (
                                    <tr key={'01' + index} className={`${inspector.estatus === 'En capacitación' ? estilos.cuadroCapacitacion : ''}`}>
                                        <td className='text-center'> <img width={'120px'} className={`img-fluid`} src={'https://www.danielcolombo.com/wp-content/uploads/2018/11/ejecutivo-a-emprendedor-hombre-sonriente-daniel-colombo.jpg'}></img></td>
                                        <td ><h5>{inspector.nombre} {inspector.apellidos}</h5>
                                            {inspector.estatus === 'En capacitación' ? <h4 style={{ fontWeight: 'bold', color: 'green' }} >En capacitación</h4> : <></>}

                                            Zona:<strong>EX - 01 GUERRERO-CDMX-PUE</strong>
                                        </td>

                                        {
                                            //<td >Visitas realizadas: 234 <br />
                                            //    Desempeño:
                                            //    <label style={{ color: 'green', fontWeight: 'bold' }}>Alto</label><br></br>
                                            //</td>
                                        }
                                        <td className='text-center'><br /><strong>Tarjeta de Gasolína:</strong> <br></br>5062 5416 0239 0012 <br /><br />
                                            <strong>Auto asignado:</strong><br></br>VERSA<br />
                                        </td>
                                        <td >
                                            <input type='text' className='form-control'></input>
                                        </td>
                                        <Modal
                                            open={openReasignarVisita}
                                            onClose={handleCloseReasignarVisita}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={style}>
                                                <Typography id="modal-modal-title" variant="h4" component="h2">
                                                    Reasignar Zona
                                                </Typography>
                                                <Typography id="modal-modal-description" sx={{ mt: 2 }} variant="h5" >
                                                    {JSON.stringify(inspector)}
                                                    ¿Que Zona deseas reasignar a: <strong>{inspector.nombre} {inspector.apellidos}</strong> ?
                                                    <br></br><br></br>
                                                </Typography>

                                                <Formik
                                                    initialValues={initialStateFormik}
                                                    validate={values => {
                                                        const errors = {};
                                                        return errors;
                                                    }}

                                                >
                                                    <Form>
                                                        <div className={`container ${estilos.contenedorForm}`}>

                                                            <div className='row'>
                                                                <div className='col-md-4'>

                                                                </div>
                                                                <div className='col-md-4'>
                                                                    <label htmlFor="zona">Zona:</label><br />
                                                                    <Field as="select" name="zona" className='form-control'>
                                                                        <option key='0' value='default'>Seleccione una zona de la lista</option>
                                                                        <option value='EX - 02- MICHOACÁN-ZAC-JAL'>EX - 02- MICHOACÁN-ZAC-JAL</option>
                                                                        <option value='EX - 03- SLP DURANGO, GTO'>EX - 03- SLP DURANGO, GTO</option>
                                                                        <option value='EX - 01 GUERRERO-CDMX-PUE '>EX - 01 GUERRERO-CDMX-PUE </option>
                                                                        <option value='OX01 VIP'>OX01 VIP</option>
                                                                        <option value='OX02-MATATLAN 1'>OX02-MATATLAN 1</option>

                                                                    </Field>
                                                                    <ErrorMessage name="puesto" component="div" className={`${estilos.error}`} /><br />
                                                                </div>

                                                                <div className='col-md-4'>

                                                                </div>

                                                            </div>
                                                            <br></br><br></br>
                                                            <div className='text-center'>
                                                                <button onClick={handleCloseReasignarVisita} type="submit" className='btn btn-success'>
                                                                    Reasignar
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </Form>


                                                </Formik>


                                            </Box>
                                        </Modal>

                                        <Modal
                                            open={openEstadisticas}
                                            onClose={handleCloseEstadisticas}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={style}>
                                                <Typography id="modal-modal-title" variant="h4" component="h2">
                                                    Estadísticas
                                                </Typography>
                                                <br /><br />

                                                <LineChart width={1100} height={300} data={data}>
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                                                    <Line type="monotone" dataKey="uv" stroke="#8884d8" />
                                                    <Line type="monotone" dataKey="pv" stroke="#82ca9d" />
                                                </LineChart>

                                            </Box>
                                        </Modal>

                                        <Modal
                                            open={openCredencial}
                                            onClose={handleCloseCredencial}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={style}>
                                                <CredencialComponent key={index + 'credencial'} inspector={inspector}></CredencialComponent>
                                            </Box>
                                        </Modal>
                                        <td className={`text-center`}>
                                            <button onClick={() => props.onModify(inspector)} className='btn btn-sm btn-outline-warning'>Modificar </button>
                                            <button onClick={() => handleRemoveInspector(inspector.id)} className='btn btn-sm btn-outline-danger'>Eliminar </button><br></br>
                                            <button onClick={handleOpenReasignarVisita} className='btn btn-sm btn-outline-primary'>Reasignar Zona </button>
                                            <button onClick={handleOpenEstadisticas} className='btn btn-sm btn-outline-success'>Ver estadísticas</button>
                                            {
                                                inspector.estatus === 'En capacitación' ? (
                                                    <button onClick={handleOpenEstadisticas} className='btn btn-sm btn-outline-secondary'>Promover a Inspector</button>
                                                ) : (<></>)
                                            }


                                        </td>
                                    </tr>
                                )
                            })
                        }

                    </tbody>

                </table>
            </div>
        </Fragment>
    );
};


export default withRouter(TablaInspectoresComponent)
